import { makeRunColumnAction } from '../../common-actions/run-column.action';
import { LlmColumnModel } from '../llm-column.model';
import { LLMColumnSnapshotAction } from './llm-column-snapshot.action';
import { LlmRunFromStartAction } from './run-from-start.action';

export class LlmRunColumnAction extends makeRunColumnAction(
  'Run LLM Column',
  LlmColumnModel,
  LlmRunFromStartAction,
  LLMColumnSnapshotAction
) {}
